import React from 'react'
import './index.scss'
import { useTranslation } from 'react-i18next'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { ExclamationCircleIcon } from '@heroicons/react/24/solid'

export const InfoAlert = (
  {
    closeInfoAlert
  } : {
    closeInfoAlert: any
  }
) => {
  const { t } = useTranslation()
  return (
    <div className='info-alert' role='alert' aria-label='info-alert'>
      <div className='info-alert-header'>
        <div className='info-alert-head' aria-label='info-icon'>
          <ExclamationCircleIcon title='Info Icon' />
          <h3 role='heading'>{t('HOME.INFO')}</h3>
        </div>
        <button
          type='button'
          className='close-btn'
          onClick={closeInfoAlert}
          aria-label={String(t('HOME.CLOSE_INFO_ALERT'))}
        >
          <XMarkIcon aria-label='close-icon' title='Close Icon' />
        </button>
      </div>
      <div className='info-alert-body'>
        <p>{t('HOME.INFO_TEXT')}</p>
      </div>
    </div>
  )
}